import config from '@dataroom/config';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { AlertsType } from './AlertsType';

export const getTitle = (alertType: AlertsType) => ({
  [AlertsType.FileUpload]: 'File Upload Alerts',
  [AlertsType.StagingFileUpload]: 'Staging Upload Alerts',
  [AlertsType.AccessRequest]: 'Access Request Alerts',
})[alertType];

export const getDescription = (alertType: AlertsType, tenant: DataroomTenant) => ({
  [AlertsType.FileUpload]: `File Upload Alerts notify you of new files uploaded to
    the ${ config[tenant].options.tenantLabelSm }.`,
  [AlertsType.StagingFileUpload]: 'File Upload Alerts notify you of new files uploaded to the staging area.',
  [AlertsType.AccessRequest]: `Access Request Alerts notify you of contacts who request access to
    the ${ config[tenant].options.tenantLabelSm }.`,
})[alertType];
